import { M } from "@angular/cdk/keycodes";
import { AnaColumn } from "../forms-template.service";
import { aspect } from "./aspect";
import { createGridConfig } from "./gridSettings/gridSettings";

const campoListaMultiT =
{
  itemType: "group", caption: "Opzioni campo lista con template", colCount: "3", class: '', groupDataField: 'campoListaMultiSelect', data: [

    { type: 'campo', dataField: "dataSource", dataType: "", caption: "Nome API", colVisible: false, width: 12 + 'vw', colSpan: '3' },


    { type: 'campo', dataField: "service", dataType: "", caption: "Service templae", colVisible: false, width: 12 + 'vw' },
    { type: 'campo', dataField: "displayExpr", dataType: "", caption: "Campo da mostrare", colVisible: false, width: 12 + 'vw', },
    { type: 'campo', dataField: "valueExpr", dataType: "", caption: "Valore Expr", colVisible: false, width: 12 + 'vw', disabled: true, disableOnUpdate: true },

    { type: 'campo', dataField: "captionD", dataType: "", caption: "Titolo popup", colVisible: false, width: 12 + 'vw', colSpan: '3' },

    {
      type: 'campo', dataField: "queryString", dataType: "", caption: "Query string(API)",
      placeHolder: '?id=$idDelCampoUsatoComeFiltro',
      colVisible: false, width: 31.8 + 'vw',
      helpText: 'Quando una getAll in un api contine un data field della form come filtro'
    },
    { type: 'empty', dataField: "", dataType: "", caption: "", colVisible: false },
    { type: 'empty', dataField: "", dataType: "", caption: "", colVisible: false },

    {
      type: 'campo', dataField: "filterStatic", dataType: "", caption: "Filtro statico",
      placeHolder: '?nomeTabella=sedi',
      colVisible: false, width: 31.8 + 'vw',
      helpText: 'Quando una getAll in un api contine un filtro statico'
    },
    { type: 'empty', dataField: "", dataType: "", caption: "", colVisible: false },
    { type: 'empty', dataField: "", dataType: "", caption: "", colVisible: false },

    {
      type: 'campo', dataField: "componentType", dataType: "", caption: "Nica Anagrafica", defaultValue: 'dynamicGrid', colVisible: false, width: 12 + 'vw',
      disabled: true, disableOnUpdate: true

    },
    { type: 'campo', dataField: "related", dataType: "", caption: "Campi relazionati", colVisible: false, width: 12 + 'vw' },
    {
      type: 'campoSpecial', dataField: "inLine", dataType: "", caption: "Popup si/no ", colVisible: false, width: 12 + 'vw',
      editorType: 'dxSelectBox',
      lista: {
        static: true,
        displayExpr: 'descrizione',
        valueExpr: 'id',
        dataSource: '',
        items: [
          {
            id: 'inLine', descrizione: 'Si'
          },
          {
            id: '', descrizione: 'No'
          }
        ],
      }
    },

    { type: 'empty', dataField: "", dataType: "", caption: "Avanzate", colSpan: '3' },

    { type: 'campo', dataField: "campoTabRif", dataType: "", caption: "Campo di riferimento", colVisible: false, helpText: 'Campo di rif. per le operazioni salvataggio', width: 12 + 'vw' },
    { type: 'campo', dataField: "keyUnique", dataType: "", caption: "Chiave univoca", colVisible: false, width: 12 + 'vw' },
    {
      type: 'campoSpecial', dataField: "selectionMode", dataType: "", caption: "Mod.sel.righe", colVisible: false,
      editorType: 'dxSelectBox',
      lista: {
        static: true,
        displayExpr: 'descrizione',
        valueExpr: 'id',
        dataSource: '',
        items: [
          {
            id: 'multiple', descrizione: 'Multipla'
          },
          {
            id: 'single', descrizione: 'Singola'
          }
        ],
      }
    },

    {
      type: 'campoSpecial', dataField: "mode", dataType: "", caption: "Editor griglia", colVisible: false, helpText: "Comportamento dell'editor griglia",
      editorType: 'dxSelectBox',
      lista: {
        static: true,
        displayExpr: 'descrizione',
        valueExpr: 'id',
        dataSource: '',
        items: [
          {
            id: 'cell', descrizione: 'Cella'
          },
          {
            id: 'row', descrizione: 'Riga'
          }
        ],
      }
    },
    { type: 'empty', dataField: "", dataType: "", caption: "", colVisible: false },
    { type: 'empty', dataField: "", dataType: "", caption: "", colVisible: false },

    { type: 'campo', dataField: "allowUpdating", dataType: "", caption: "Abilita inserimento", colVisible: false, editorType: 'dxCheckBox' },
    { type: 'campo', dataField: "allowDeleting", dataType: "", caption: "Abilita elimina", colVisible: false, editorType: 'dxCheckBox' },
    { type: 'campo', dataField: "allowAdding", dataType: "", caption: "Abilita modifica", colVisible: false, editorType: 'dxCheckBox' },

    { type: 'campo', dataField: "searchAndSelect", dataType: "", caption: "Abilita ricerca e seleziona", colVisible: false, editorType: 'dxCheckBox', colSpan: '2' },
    { type: 'campo', dataField: "searchAndSelectDataSource", dataType: "", caption: "API di ricerca", colVisible: false, colSpan: '1' },


    { type: 'campo', dataField: "height", dataType: "", caption: "Altezza griglia", colVisible: false },
    { type: 'empty', dataField: "", dataType: "", caption: "", colVisible: false },
    { type: 'empty', dataField: "", dataType: "", caption: "", colVisible: false },


  ]
}


const campoListaT:AnaColumn =


{
  itemType: "group", caption: "Opzioni campo lista", colCount: "2", colSpan: '2', class: '', groupDataField: 'campoLista', data: [

    {
      type: 'campoSpecial', dataField: "lista_static", dataType: "boolean", caption: "Lista statica", colVisible: false, editorType: 'dxSelectBox',
      width: 12 + 'vw',
      lista: {
        static: true,
        displayExpr: 'descrizione',
        valueExpr: 'id',
        dataSource: '',
        items: [
          {
            id: true, descrizione: 'Si'
          },
          {
            id: false, descrizione: 'No'
          }
        ],


      },
    },

    {
      type: 'campo', dataField: "lista_dataSource", dataType: "", caption: "API", colVisible: false, width: 12 + 'vw',

    },


    {
      type: 'campo', dataField: "lista_displayExpr", dataType: "", caption: "Campo da mostrare", colVisible: false, width: 12 + 'vw',
      validation: [
        { type: "required", message: "Campo Obbligatorio" },

      ],
    },
    {
      type: 'campo', dataField: "lista_valueExpr", dataType: "", caption: "Valore Expr", colVisible: false, width: 12 + 'vw',
      validation: [
        { type: "required", message: "Campo Obbligatorio" },

      ],
    },

    {
      type: 'campo', dataField: "lista_queryString", dataType: "", caption: "Query string(API)",
      placeHolder: '?id=$idDelCampoUsatoComeFiltro',
      colVisible: false, width: 31.8 + 'vw', colSpan: '2',
      helpText: 'Quando una getAll in un api contine un data field della form come filtro(il campo deve sempre inziare con dollaro)'
    },
    {
      type: 'campo', dataField: "lista_filter", dataType: "", caption: "Filtro statico",
      placeHolder: '?nomeTabella=sedi',
      colVisible: false, width: 31.8 + 'vw', colSpan: '2',
      helpText: 'Quando una getAll in un api contine un filtro statico'
    },


    { type: 'campo', dataField: "lista_related", dataType: "", caption: "Campi relazionati", colVisible: false, width: 12 + 'vw', colSpan: '2' },
    { type: 'campo', dataField: "lista_cascading", dataType: "", caption: "Campi a cascata", colVisible: false, width: 12 + 'vw', colSpan: '2' },


    { type: 'campo', dataField: "lista_showDropDownButton", dataType: "boolean", caption: "Bottone DropDown", colVisible: false, editorType: 'dxCheckBox', defaultValue: true },
    { type: 'campo', dataField: "lista_showClearButton", dataType: "boolean", caption: "Bottone pulisci", colVisible: false, editorType: 'dxCheckBox' },

    { type: 'campo', dataField: "lista_placeholder", dataType: "", caption: "Placeholder", colVisible: false, colSpan: '2', width: 12 + 'vw', },
    {
      type: 'campoSpecial', dataField: "lista_items", dataType: "", caption: "Items", colVisible: false, colSpan: '2',
      width: 12 + 'vw',

      labelVisible: true,
      disableOnUpdate: true,
      dynamic: {
        dataSource: '',
        service: '',
        autocomplete: false,
        checkValue: {
          checkValueMessage: '',
          forceInsert: false
        },
        valueExpr: '',
        displayExpr: 'id',
        caption: "Lista Variabili string",
        queryString: '',
        filter: '/',
        componentType: 'dynamicGrid',

        buttonOption: {
          text: 'Modalità di recupero',
          icon: 'glyphicon mdi mdi-playlist-plus',
          hint: 'Sfoglia Mod.Recupero',
          name: 'recupero',
          location: 'after',
          event: 'inLine'

        },
        settingGrid: createGridConfig({
          // qui puoi sovrascrivere le proprietà di default o aggiungerne di nuove
          height:350,
          rowAlternationEnabled: true,
          allowUpdating: true,
          allowDeleting: true,
          selectionMode: 'multiple',
          outputData: true,
          showColBlank: true,
          colonne: [
            {
              dataField: 'id',
              dataType: '',
              caption: 'Codice',
              width: 70,
              hideOnEdit: false
            },
            {
              dataField: 'descrizione',
              dataType: '',
              width: 250,
              caption: 'Descrizione',
              hideOnEdit: false
            },
          ],

        }),
      }
    },




    /*
      
      buttonOption: {
        text: 'Destinatario',
        icon: 'glyphicon mdi mdi-playlist-plus',
        hint: 'Sfoglia Destinatario',
        name: 'Destinatario',
        location: 'after',
      }
    */

  ]

}


const campoDynamicCD:AnaColumn =
{
  itemType: "group", caption: "Opzioni campo", colCount: "3", colSpan: '2', class: '', groupDataField: 'campoDynamicT', data: [

    {
      type: 'campo', dataField: "dataSource", dataType: "", caption: "API", colVisible: false, width: 12 + 'vw',
      validation: [
        { type: "required", message: "Campo Obbligatorio" },

      ],
    },
    { type: 'empty', dataField: "", dataType: "", caption: "", colVisible: false },
    { type: 'empty', dataField: "", dataType: "", caption: "", colVisible: false },

    { type: 'campo', dataField: "service", dataType: "", caption: "Service templae", colVisible: false, width: 12 + 'vw' },
    {
      type: 'campo', dataField: "displayExpr", dataType: "", caption: "Campo da mostrare", colVisible: false, width: 12 + 'vw',
      validation: [
        { type: "required", message: "Campo Obbligatorio" },

      ],
    },
    {
      type: 'campo', dataField: "valueExpr", dataType: "", caption: "Valore Expr", colVisible: false, width: 12 + 'vw',
      validation: [
        { type: "required", message: "Campo Obbligatorio" },

      ],
    },

    { type: 'campo', dataField: "captionD", dataType: "", caption: "Titolo popup", colVisible: false, width: 12 + 'vw' },
    { type: 'empty', dataField: "", dataType: "", caption: "", colVisible: false },
    { type: 'empty', dataField: "", dataType: "", caption: "", colVisible: false },

    {
      type: 'campo', dataField: "queryString", dataType: "", caption: "Query string(API)",
      placeHolder: '?id=$idDelCampoUsatoComeFiltro',
      colVisible: false, width: 31.8 + 'vw', colSpan: '3',
      helpText: 'Quando una getAll in un api contine un data field della form come filtro (il campo deve inziare sempre con il dollaro)'
    },
    {
      type: 'campo', dataField: "filterStatic", dataType: "", caption: "Filtro statico",
      placeHolder: '?nomeTabella=sedi',
      colVisible: false, width: 31.8 + 'vw', colSpan: '3',
      helpText: 'Quando una getAll in un api contine un filtro statico'
    },
    {
      type: 'campo', dataField: "componentType", dataType: "", caption: "Nica Anagrafica", defaultValue: 'grid', colVisible: false, width: 12 + 'vw',
      disabled: true, disableOnUpdate: true

    },
    { type: 'campo', dataField: "related", dataType: "", caption: "Campi relazionati", colVisible: false, width: 12 + 'vw', },
    { type: 'empty', dataField: "", dataType: "", caption: "", colVisible: false },


    {
      type: 'campoSpecial', dataField: "autocomplete", dataType: "", caption: "Autocomplete", colVisible: false, width: 12 + 'vw',
      editorType: 'dxSelectBox',
      lista: {
        static: true,
        displayExpr: 'descrizione',
        valueExpr: 'id',
        dataSource: '',
        items: [
          {
            id: true, descrizione: 'Si'
          },
          {
            id: false, descrizione: 'No'
          }
        ],


      },
      validation: [{ type: "required", message: "Campo Obbligatorio" }],
    },

    {
      type: 'campo', dataField: "forceInsert", dataType: "", caption: "Forza inserimento", colVisible: false, editorType: 'dxCheckBox',
      width: 12 + 'vw',
      disabled: true

    },
    {
      type: 'campo', dataField: "checkValueMessage", dataType: "", caption: "Messaggio da mostrare", colVisible: false,
      width: 12 + 'vw', disabled: true
    },


    { type: 'empty', dataField: "enableEditor", dataType: "", caption: "Abilita editor", colSpan: '3' },
    { type: 'campo', dataField: "add", dataType: "", caption: "Abilita inserimento", colVisible: false, editorType: 'dxCheckBox' },
    { type: 'campo', dataField: "remove", dataType: "", caption: "Abilita elimina", colVisible: false, editorType: 'dxCheckBox' },
    { type: 'campo', dataField: "update", dataType: "", caption: "Abilita modifica", colVisible: false, editorType: 'dxCheckBox' }
    /*
      
      buttonOption: {
        text: 'Destinatario',
        icon: 'glyphicon mdi mdi-playlist-plus',
        hint: 'Sfoglia Destinatario',
        name: 'Destinatario',
        location: 'after',
      }
    */

  ]

}

const campoDynamicT:AnaColumn =


{
  itemType: "group", caption: "Opzioni campo dinamico", colCount: "3", colSpan: '2', class: '', groupDataField: 'campodynamic_', data: [

    {
      type: 'campo', dataField: "dynamic_dataSource", dataType: "", caption: "Nome API", colVisible: false, width: 12 + 'vw',
      validation: [
        { type: "required", message: "Campo Obbligatorio" },

      ],
    },
    { type: 'empty', dataField: "", dataType: "", caption: "", colVisible: false },
    { type: 'empty', dataField: "", dataType: "", caption: "", colVisible: false },

    { type: 'campo', dataField: "dynamic_service", dataType: "", caption: "Service templae", colVisible: false, width: 12 + 'vw' },

    {
      type: 'campo', dataField: "dynamic_displayExpr", dataType: "", caption: "Campo da mostrare", helpText: 'Campo da mostrare del db', colVisible: false, width: 12 + 'vw',


    },
    { type: 'campo', dataField: "dynamic_valueExpr", dataType: "", caption: "Valore Expr", helpText: 'Campo da salvare nel DB', colVisible: false, width: 12 + 'vw' },

    { type: 'campo', dataField: "dynamic_caption", dataType: "", caption: "Titolo popup", colVisible: false, width: 12 + 'vw' },
    { type: 'empty', dataField: "", dataType: "", caption: "", colVisible: false },
    { type: 'empty', dataField: "", dataType: "", caption: "", colVisible: false },

    {
      type: 'campo', dataField: "dynamic_queryString", dataType: "", caption: "Query string(API)",
      placeHolder: '?id=$idDelCampoUsatoComeFiltro',
      colVisible: false, width: 31.8 + 'vw', colSpan: '3',
      helpText: 'Quando una getAll in un api contine un data field della form come filtro'
    },

    {
      type: 'campo', dataField: "dynamic_filterStatic", dataType: "", caption: "Filtro statico",
      placeHolder: '?nomeTabella=sedi',
      colVisible: false, width: 31.8 + 'vw', colSpan: '3',
      helpText: 'Quando una getAll in un api contine un filtro statico'
    },
    {
      type: 'campo', dataField: "dynamic_componentType", dataType: "", caption: "Nica Anagrafica", defaultValue: 'dynamicGrid', colVisible: false, width: 12 + 'vw',
      disabled: true, disableOnUpdate: true

    },
    {
      type: 'campo',
      dataField: "dynamic_related_0",
      dataType: "",
      caption: "Campi relazionat 1",
      colVisible: false, width: 12 + 'vw',
    },
    {
      type: 'campo',
      dataField: "dynamic_related_1",
      dataType: "",
      caption: "Campi relazionato 2",
      colVisible: false, width: 12 + 'vw',
    },
    {
      type: 'campo',
      dataField: "dynamic_related_2",
      dataType: "",
      caption: "Campi relazionati 3",
      colVisible: false, width: 12 + 'vw',
    },
    {
      type: 'campo',
      dataField: "dynamic_related_3",
      dataType: "",
      caption: "Campi relazionati 4",
      colVisible: false, width: 12 + 'vw',
    },
    {
      type: 'campo',
      dataField: "dynamic_related_4",
      dataType: "",
      caption: "Campi relazionati 5",
      colVisible: false, width: 12 + 'vw',
    },
    { type: 'empty', dataField: "", dataType: "", caption: "", colVisible: false },


    {
      type: 'campoSpecial', dataField: "dynamic_autocomplete", dataType: "", caption: "Autocomplete", colVisible: false, width: 12 + 'vw',
      editorType: 'dxSelectBox', hideOnEdit: true,
      lista: {
        static: true,
        displayExpr: 'descrizione',
        valueExpr: 'id',
        dataSource: '',
        items: [
          {
            id: true, descrizione: 'Si'
          },
          {
            id: false, descrizione: 'No'
          }
        ],


      },
      validation: [{ type: "required", message: "Campo Obbligatorio" }],
    },

    {
      type: 'campo', dataField: "dynamic_checkValue_forceInsert", dataType: "", caption: "Forza inserimento", colVisible: false, editorType: 'dxCheckBox',
      width: 12 + 'vw'


    },
    {
      type: 'campo', dataField: "dynamic_checkValue_checkValueMessage", dataType: "", caption: "Messaggio da mostrare", colVisible: false,

      width: 12 + 'vw'
    },

    {
      type: 'campo', dataField: "dynamic_caption", dataType: "", caption: "Titolo PopUp", colVisible: false,

      colSpan: '3'
    },



    { type: 'empty', dataField: "dynamic_enableEditor", dataType: "", caption: "Abilita editor griglia", colSpan: '3' },

    { type: 'campo', dataField: "dynamic_settingGrid_allowAdding", dataType: "boolean", caption: "Abilita inserimento", colVisible: false, editorType: 'dxCheckBox' },
    { type: 'campo', dataField: "dynamic_settingGrid_allowDeleting", dataType: "boolean", caption: "Abilita elimina", colVisible: false, editorType: 'dxCheckBox' },
    { type: 'campo', dataField: "dynamic_settingGrid_allowUpdating", dataType: "boolean", caption: "Abilita modifica", colVisible: false, editorType: 'dxCheckBox' },



    { type: 'campo', dataField: "dynamic_settingGrid_campoTabRif", dataType: "", caption: "dataField di riferimento", colVisible: false },
    { type: 'campo', dataField: "dynamic_settingGrid_masterKey", dataType: "", caption: "Campo masterKey", colVisible: false },
    { type: 'campo', dataField: "dynamic_settingGrid_keyUnique", dataType: "", caption: "Chiave univoca", colVisible: false },
    {
      type: 'campoSpecial', dataField: "dynamic_settingGrid_modeEditor", dataType: "", caption: "Editor griglia", colVisible: false,
      editorType: 'dxSelectBox',

      lista: {
        static: true,
        displayExpr: 'descrizione',
        valueExpr: 'id',
        dataSource: '',
        items: [
          {
            id: 'cell', descrizione: 'cella'
          },
          {
            id: 'row', descrizione: 'Riga'
          },
          {
            id: 'popup', descrizione: 'Pop Up'
          }
        ]

      }
    },
    {
      type: 'campoSpecial', dataField: "dynamic_settingGrid_selectionMode", dataType: "", caption: "Tipo di selezione riga", colVisible: false,
      editorType: 'dxSelectBox',

      lista: {
        static: true,
        displayExpr: 'descrizione',
        valueExpr: 'id',
        dataSource: '',
        items: [
          {
            id: 'single', descrizione: 'Singola riga'
          },
          {
            id: 'multiple', descrizione: 'Multipla'
          },

        ]

      }
    },
    { type: 'campo', dataField: "dynamic_settingGrid_showColBlank", dataType: "boolean", caption: "Mostra righe vuote", colVisible: false, editorType: 'dxCheckBox' },
    { type: 'campo', dataField: "dynamic_settingGrid_showFilterSearch", dataType: "boolean", caption: "Mostra ricerca campi", colVisible: false, editorType: 'dxCheckBox' },

    { type: 'campo', dataField: "dynamic_settingGrid_campoTabRif", dataType: "", caption: "Campo di riferimento", colVisible: false, helpText: 'Campo di rif. per le operazioni salvataggio', width: 12 + 'vw' },
    {type:'empty',dataField:'',dataType:''},
    
    {
      type: 'campoSpecial', dataField: "dynamic_settingGrid_colonneD", dataType: "", caption: "Colonne griglia",
      colSpan: '3',
      dynamic: {
        dataSource: '',
        service: '',
        autocomplete: false,

        valueExpr: '',
        displayExpr: 'dataField',
        caption: "Crea Colonne string",
        queryString: '',
        filter: '',
        componentType: 'dynamicGrid',
        related: ['dynamic_settingGrid_colonne'],
        buttonOption: {
          text: 'colonne',
          icon: 'glyphicon mdi mdi-playlist-plus',
          hint: 'Sfoglia Colonne',
          name: 'recupero',
          location: 'after',


        },
        settingGrid: createGridConfig({
          // qui puoi sovrascrivere le proprietà di default o aggiungerne di nuove
          height:350,
          masterKey: 'dataField',
          selectionMode: 'multiple',
          allowUpdating: true,
          allowDeleting: true,
          showColBlank: true,
          colonne: [
            {
              dataField: 'dataField',
              dataType: '',
              caption: 'Data Field',
              hideOnEdit: false,

            },
            {
              dataField: 'caption',
              dataType: '',
              caption: 'Caption',
              hideOnEdit: false
            },
            {
              dataField: 'allowEditing',
              dataType: 'boolean',
              caption: 'Campo modificabile',
              hideOnEdit: false
            },
            {
              dataField: 'showEditorAlways',
              dataType: 'boolean',
              caption: 'Mostra sempre l\'editor',
              hideOnEdit: false
            },
          ],

        }),
      }
    },
  ]

}






export let campoSemplice: AnaColumn[] = [

  {
    itemType: "group", caption: "Campo Semplice", colCount: "2", colSpan: '2', class: '', data: [

      {
        type: 'campo', dataField: 'type', colVisible: false, caption: 'Tipo', disableOnUpdate: true, disabled: true,

      },


      { type: 'campo', dataField: "colSpan", dataType: "", caption: "Spaziatura Campo", helpText: 'Attenzione! impostare lo stesso valore della n colonne gruppo per ottenere un campo sulla stessa riga', colVisible: false, width: 3 + 'vw' },
      {
        type: 'campo', dataField: "dataField", dataType: "", caption: "Nome dataField", colVisible: false, maxLength: '45', colSpan: '2',
        validation: [
          { type: "required", message: "Campo Obbligatorio" },

        ],
      },

      { type: 'campo', dataField: "width", dataType: "", caption: "Larghezza", colVisible: false, },
      {
        type: 'campoSpecial', dataField: "widthUm", dataType: "", caption: "", colVisible: false, labelVisible: false,
        editorType: 'dxSelectBox',
        lista: {
          static: true,
          displayExpr: 'descrizione',
          valueExpr: 'id',
          dataSource: '',
          items: [
            {
              id: 'px', descrizione: 'Pixel'
            },
            {
              id: 'vw', descrizione: 'View width'
            }
          ]

        }
      },
      { type: 'campo', dataField: "maxLength", dataType: "", caption: "Max n.Caratteri", colVisible: false, colSpan: '2', },


      { type: 'campo', dataField: "disableOnUpdate", dataType: "boolean", caption: "tipo ReadOnly", colVisible: false, editorType: 'dxCheckBox' },
      { type: 'campo', dataField: "hideOnEdit", dataType: "boolean", caption: "Nascosto", colVisible: false, editorType: 'dxCheckBox' },


    ]
  },

  {
    itemType: "group", caption: "Opzioni label", colCount: "2", class: 'group-width20', data: [
      { type: 'campo', dataField: "labelVisible", dataType: "boolean", caption: "Label visibile", editorType: 'dxCheckBox', width: 2 + 'vw', colSpan: '2' },

      { type: 'campo', dataField: "caption", dataType: "", caption: "Label", colVisible: false, colSpan: '2' },

      {
        type: 'campoSpecial', dataField: "labelPosition", dataType: "", caption: "Posizione",
        editorType: 'dxSelectBox',
        lista: {
          static: true,
          displayExpr: 'descrizione',
          valueExpr: 'id',
          dataSource: '',
          items: [
            {
              id: '', descrizione: ''
            },
            {
              id: 'left', descrizione: 'Sinistra'
            },
            {
              id: 'right', descrizione: 'Destra'
            },
            {
              id: 'top', descrizione: 'Sopra'
            },


          ]

        }
      },
      {
        type: 'campoSpecial', dataField: "labelAlignment", dataType: "", caption: "Allineamento",
        editorType: 'dxSelectBox',

        lista: {
          static: true,
          displayExpr: 'descrizione',
          valueExpr: 'id',
          dataSource: '',
          items: [
            {
              id: '', descrizione: 'Non specificato'
            },
            {
              id: 'left', descrizione: 'Sinistra'
            },
            {
              id: 'right', descrizione: 'Destra'
            },
            {
              id: 'center', descrizione: 'center'
            },
          ]

        }
      },

      {
        type: 'campoSpecial', dataField: "showColon", dataType: "boolean", caption: "Mostra asterisco", editorType: 'dxSelectBox',

        lista: {
          static: true,
          displayExpr: 'descrizione',
          valueExpr: 'id',
          dataSource: '',
          items: [
            {
              id: '', descrizione: ''
            },
            {
              id: 'false', descrizione: 'No'
            },
            {
              id: 'true', descrizione: 'Si'
            },

          ]

        }
      },
      { type: 'campo', dataField: "labelWidth", dataType: "", caption: "Larghezza", colVisible: false, width: 5 + 'vw' },

    ]
  },
  {
    itemType: "group", caption: "Opzioni griglia", colCount: "1", class: 'group-width20', visible: true, data: [
      {
        type: 'campo', dataField: "colVisible", dataType: "boolean", caption: "Campo visibile in griglia", defaultValue: 'false',

        editorType: 'dxCheckBox',


      },

      { type: 'campo', dataField: "colWidth", dataType: "", caption: "Larghezza colonna", colVisible: false, },

      { type: 'campo', dataField: "orderGriglia", dataType: "", caption: "Ord.campo in griglia", colVisible: false, },

      {
        type: 'campoSpecial', dataField: "dataType", dataType: "", caption: "Tipo colonna", colVisible: false,
        editorType: 'dxSelectBox',
        lista: {
          static: true,
          displayExpr: 'descrizione',
          valueExpr: 'id',
          dataSource: '',
          items: [
            {
              id: '', descrizione: 'Non definito'
            },
            {
              id: 'string', descrizione: 'Stringa'
            },
            {
              id: 'date', descrizione: 'Data'
            },
            {
              id: 'datetime', descrizione: 'Data e ora'
            },
            {
              id: 'boolean', descrizione: 'Boolean'
            },
            {
              id: 'number', descrizione: 'Numerico'
            }
          ]

        }
      },

    ]
  },
  {
    itemType: "group", caption: "Altre Opzioni", colCount: "1", class: 'collapse-group', data: [
      {
        type: 'campoSpecial', dataField: "editorType", dataType: "", caption: "Editor UI di DevExtreme", colVisible: false,


        editorType: 'dxSelectBox',
        lista: {
          static: true,
          displayExpr: 'descrizione',
          valueExpr: 'id',
          dataSource: '',
          items: [
            {
              id: '', descrizione: '-'
            },
            {
              id: 'dxTextArea', descrizione: 'TextBox'
            },
            {
              id: 'dxTextArea', descrizione: 'TextArea'
            },
            {
              id: 'dxSelectBox', descrizione: 'SelectBox'
            },
            {
              id: 'dxCheckBox', descrizione: 'CheckBox'
            },
            {
              id: 'dxColorBox', descrizione: 'ColorBox'
            },
            {
              id: 'dxHtmlEditor', descrizione: 'HtmlEditor'
            },
            {
              id: 'dxNumberBox', descrizione: 'NumberBox'
            },

          ]

        }, helpText: 'se vuoto di default è dxTextBox'
      },
      { type: 'campo', dataField: "helpText", dataType: "", caption: "Descrizione aggiuntiva", colVisible: false, },
      { type: 'campo', dataField: "editorClass", dataType: "", caption: "Classe css per l'editor", colVisible: false, },
      { type: 'campo', dataField: "attr", dataType: "", caption: "CSS style", colVisible: false, helpText: "Aggiungi all'editor dello stile css", },
      { type: 'campo', dataField: "mask", dataType: "", caption: "Mask", colVisible: false, helpText: 'Formato personalizzato della stringa immessa.' },


    ]
  },
  {
    itemType: "group", caption: "Validazione", colCount: "1", class: '', visible: true, data: [

      { type: 'campo', dataField: "obbligatorio", dataType: "boolean", caption: "Campo obbligatorio", colVisible: false, hideOnEdit: false, editorType: 'dxCheckBox' },
      { type: 'campo', dataField: "type", defaultValue: 'required', dataType: "", caption: "Tipo di validazione", colVisible: false, disableOnUpdate: true, hideOnEdit: false },
      { type: 'campo', dataField: "message", dataType: "", caption: "Messaggio", colVisible: false, hideOnEdit: false },
    ]
  }

]
const campoButtonT:AnaColumn = {

  itemType: "group", caption: "Opzioni campo bottone", colCount: "1", colSpan: '', class: '', groupDataField: 'campoButton_', data: [

    {
      type: 'campo', dataField: "button_text", dataType: "", caption: "Testo", colVisible: false, width: 12 + 'vw',
      validation: [
        { type: "required", message: "Campo Obbligatorio" },

      ],
    },
    {
      type: 'campo', dataField: "button_name", dataType: "", caption: "Nome", colVisible: false, width: 12 + 'vw',
      validation: [
        { type: "required", message: "Campo Obbligatorio" },

      ],
    },
    {
      type: 'campoSpecial', dataField: "button_location", dataType: "", caption: "Posizione", colVisible: false, width: 12 + 'vw',
      validation: [
        { type: "required", message: "Campo Obbligatorio" },

      ],
      editorType:'dxSelectBox',
      lista: {
        dataSource: '',
        valueExpr: 'id',
        displayExpr: 'descrizione',
        static: true,
        items: [
          {
            id: '', descrizione: '-'
          },
          {
            id: 'after', descrizione: 'after'
          },
          {
            id: 'before', descrizione: 'before'
          },
         
        ]
      }
    },
    {
      type: 'campo', dataField: "button_event", dataType: "", caption: "Event", 
      class:'d-none',
      colVisible: false, width: 12 + 'vw',
      defaultValue:'OptionalIconButtonClick',
     
    },
    {
      type: 'campo', dataField: "button_icon", dataType: "", caption: "Event", 
      class:'d-none',
      colVisible: false, width: 12 + 'vw',
      defaultValue:'icon: "glyphicon mdi mdi-file-search-outline"',
     
    },
    {
      type: 'campo', dataField: "button_outPutValue", dataType: "boolean", caption: "Usa valore del campo", 
      editorType:'dxCheckBox',
      colVisible: false, 
      
     
    },
    {
      type: 'campo', dataField: "button_related_0", dataType: "", caption: "Campo realzionato 1", 
      width: 12 + 'vw',
      colVisible: false, 
      
     
    },
    {
      type: 'campo', dataField: "button_related_1", dataType: "", caption: "Campo realzionato 2", 
      width: 12 + 'vw',
      colVisible: false, 
      
     
    },
  ]
  }    


export const campoDynamic = campoSemplice.concat(campoDynamicT);

export const campoCodiceDesc = campoSemplice.concat(campoDynamicCD);
export const campoLista = campoSemplice.concat(campoListaT);
export const campoListaM = campoSemplice.concat(campoListaMultiT);
export const campoButton = campoSemplice.concat(campoButtonT)
export const generaConfigurazione: AnaColumn[] = [
  {
    configuration:
    {
      titleGriglia: '',
      titleForm: 'Genera Anagrafica',
      breadcrumbCaption: 'Configurazione',
      campoTitle: [],
      service: 'generaConfigurazione',
      api: 'ModelloDiStampa',
      filterList: '/',
      filterEditor: '/$',
      helpDoc: '',
      formType: 'simple',
      queryFilter: [],
      idTabRif: [],

      masterKey: 'id',
      nCol: 2,
      /* toolbarSettings: {
        service: 'movimentiToolbar',
        displayButtons: [],
        disabledButtons: []
      } */


    }

  },
  {
    itemType: "group", caption: "", colCount: "1", colSpan: '2', class: '', visible: false, data: [
      {
        type: 'campo', dataField: 'id', colVisible: true, caption: 'codice', hideOnEdit: true


      },
      { type: 'campo', dataField: 'descrizione', colVisible: true, caption: 'descrizione', hideOnEdit: true },
    ]
  },
  {
    itemType: "group", caption: "", colCount: "1", class: 'group-width30', data: [

      {
        type: 'empty', dataField: '', caption: 'Configurazione',
      },

      {
        type: 'campo', dataField: 'titleGriglia', colVisible: false, caption: 'Nome Anagrafica',
        width: 22 + 'vw',
        validation: [
          { type: "required", message: "Campo Obbligatorio" },

        ],
      },
      { type: 'campo', dataField: "titleForm", dataType: "", caption: "Titolo Form", editorType: "", colVisible: false, width: 22 + 'vw' ,
      validation: [
        { type: "required", message: "Campo Obbligatorio" },

      ],
      },

      {
        type: 'campo', colVisible: false, dataField: "service", dataType: "", caption: "Nome del service ", width: 22 + 'vw',
        validation: [
          { type: "required", message: "Campo Obbligatorio" },

        ],
      },
      {
        type: 'campo', colVisible: false, dataField: "api", dataType: "", caption: "Nome API",
        validation: [
          { type: "required", message: "Campo Obbligatorio" },

        ],
        width: 22 + 'vw'
      },

      {
        type: 'campo', colVisible: false, dataField: "filterList", dataType: "", caption: "Filtro della GETALL",
        placeHolder: '/$nomeVariabileFiltro',


        width: 22 + 'vw',
        validation: [
          { type: "required", message: "Campo Obbligatorio" },

        ],

      },
      {
        type: 'campo', colVisible: false, dataField: "filterEditor", dataType: "", caption: "Filtro del detail",
        placeHolder: '?id=$nomeVariabileFiltro',

        width: 22 + 'vw',

        validation: [
          { type: "required", message: "Campo Obbligatorio" },

        ],

      },

      { type: 'campo', colVisible: false, dataField: "helpDoc", dataType: "", caption: "HelpDoc nome file", width: 22 + 'vw', },
      { type: 'campo', dataField: "idBreadcrumbGroup", dataType: "", caption: "Nome Gruppo appartenenza", colVisible: false, width: 22 + 'vw', },
      { type: 'campo', dataField: "breadcrumbCaption", dataType: "", caption: "Nome breadcrumb", colVisible: false, width: 22 + 'vw', },
      { type: 'campo', dataField: "campoTitle", dataType: "", caption: "Variabili nel titolo", width: 22 + 'vw', colVisible: false },
      {
        type: 'campoSpecial', dataField: "formType", dataType: "", caption: "Tipo form", width: 22 + 'vw',
        editorType: 'dxSelectBox',
        colVisible: false,
        lista: {
          dataSource: '',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          static: true,
          items: [
            {
              id: 'simple', descrizione: 'simple'
            },
            {
              id: 'tabbed', descrizione: 'tabbed'
            },
            {
              id: 'tabbedStep', descrizione: 'tabbedStep'
            }
          ]
        }


      },
      {
        type: 'campo', dataField: "nCol", dataType: "number", caption: "N.col. form", width: 22 + 'vw', colVisible: false,
        editorType: 'dxNumberBox'
      },


      {
        type: 'campoSpecial', dataField: "queryFilter", dataType: "", caption: "Campi query filter",
        width: 22 + 'vw',
        colVisible: false,
        labelVisible: true,
        disableOnUpdate: true,
        dynamic: {
          dataSource: '',
          autocomplete: false,
          checkValue: {
            checkValueMessage: '',
            forceInsert: false
          },
          valueExpr: '',
          displayExpr: '',
          caption: "Lista Variabili query string",
          queryString: '',
          filter: '/',
          componentType: 'dynamicGrid',

          buttonOption: {
            text: 'Modalità di recupero',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Mod.Recupero',
            name: 'recupero',
            location: 'after',


          },
          settingGrid: createGridConfig({
            // qui puoi sovrascrivere le proprietà di default o aggiungerne di nuove
            height:500,
            selectionMode: 'multiple',
            allowUpdating: true,
            allowDeleting: true,
            allowAdding: true,
            outputData: true,
            colonne: [
              {
                dataField: 'key',
                dataType: '',
                caption: 'Key',
                width: 70,
                hideOnEdit: false
              },
              {
                dataField: 'value',
                dataType: '',
                width: 250,
                caption: 'Value',
                hideOnEdit: false
              },
            ],

          }),
        }
      },

      {
        type: 'campoSpecial', dataField: "idTabRifDesc", dataType: "", caption: "Campi di relazionati", width: 22 + 'vw',
        colVisible: false,
        dynamic: {
          dataSource: '',
          autocomplete: false,
          checkValue: {
            checkValueMessage: '',
            forceInsert: false
          },
          valueExpr: '',
          displayExpr: 'key',
          caption: "Lista Variabili idTabRif string",
          queryString: '',
          filter: '/',
          componentType: 'dynamicGrid',
          related: ['idTabRif'],
          buttonOption: {
            text: 'Modalità di recupero',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Mod.Recupero',
            name: 'recupero',
            location: 'after',


          },
          settingGrid: createGridConfig({
            // qui puoi sovrascrivere le proprietà di default o aggiungerne di nuove
            height:500,
            masterKey: 'key',
            selectionMode: 'multiple',
            allowUpdating: true,
            allowDeleting: true,
            allowAdding: true,
            outputData: true,
            colonne: [
              {
                dataField: 'key',
                dataType: '',
                caption: 'Key',
                width: 70,
                hideOnEdit: false
              },
              {
                dataField: 'value',
                dataType: '',
                width: 250,
                caption: 'Value',
                hideOnEdit: false
              },

            ],

          }),
        }

      },

    ],
  },
  {
    itemType: "group", caption: "", colCount: "1", class: 'group-width30', data: [

      { type: 'empty', dataField: '', caption: 'Riepilogo Gruppi', colSpan: '1' },

      {
        type: 'campoComponent', labelVisible: false, colSpan: "1", dataField: 'dataGroups',
        colVisible: false,
        width: 55 + 'vw',
        dynamic: {
          dataSource: '',
          service: '',
          autocomplete: false,
          valueExpr: '',
          campoTabRif: '',
          displayExpr: '',
          filter: '',
          componentType: 'dynamicGrid',
          bodyFilter: '',
          settingGrid: createGridConfig({
            // qui puoi sovrascrivere le proprietà di default o aggiungerne di nuove
          
            allowUpdating: true,
            allowDeleting: true,
            allowAdding: true,
            colonne: [
              {
                dataField: 'id',
                dataType: '',
                caption: 'ID',
                hideOnEdit: false,
                width: 30
              },
              {
                dataField: 'groupDataField',
                dataType: '',
                caption: 'Nome Campo',
                hideOnEdit: false
              },
              {
                dataField: 'colCount',
                dataType: '',
                caption: 'Colonne gruppo',
                hideOnEdit: false
              },
            ],

          }),




        }
      }

    ]
  }

];

export const generaGruppo: AnaColumn[] = [
  {
    configuration:
    {
      titleGriglia: '',
      titleForm: 'Genera Anagrafica',
      breadcrumbCaption: 'Gruppo',
      campoTitle: [],
      service: 'generaGruppo',
      api: 'ModelloDiStampa',
      filterList: '/',
      filterEditor: '/$',
      helpDoc: '',
      formType: 'simple',
      queryFilter: [],
      idTabRif: [],
      masterKey: 'id',
      nCol: 2,


    }

  },
  {
    itemType: "group", caption: "", colCount: "3", class: 'group-width80', data: [
      {
        type: 'empty', caption: 'Dati del gruppo', colSpan: '3'
      },
      { type: 'campo', colVisible: false, dataField: "caption", dataType: "", caption: "Caption del gruppo",colSpan: '3'},

      {
        type: 'campo', colVisible: false, dataField: "groupDataField", dataType: "", caption: "ID del gruppo", maxLength: '15',
        width:'210px'
      },
      {
        type: 'campo', colVisible: false, dataField: "colCount", dataType: "", caption: "N.Colonne", 
        validation: [
          { type: "required", message: "Campo Obbligatorio" },

        ],
      },

      { type: 'campo', colVisible: false, dataField: "colSpan", dataType: "", caption: "ColSpan",},

      { type: 'campo', colVisible: false, dataField: "class", dataType: "", caption: "CSS class", colSpan:'1', width:'210px',maxLength: '15',},
      {
        type: 'campo',
        colVisible: false, dataField: "visible", dataType: "", caption: "Visibile", editorType: 'dxCheckBox',colSpan:'1',
        validation: [
          { type: "required", message: "Campo Obbligatorio" },

        ],
      },
      { type: 'campo', colVisible: false, dataField: "disabled", dataType: "boolean", caption: "Disabilitato", editorType: 'dxCheckBox', colSpan:'1'},
     
 
    ]
  },
  {
    itemType: "group", caption: "", colCount: "1", class: '', data: [
      {
        type: 'empty', caption: 'Elementi del gruppo', colSpan: '1'
      },
      {
        type: 'campoComponent', labelVisible: false, colSpan: "1", dataField: 'data',
        colVisible: false,
        width: 700 + 'px',
        dynamic: {
          dataSource: '',
          service: '',
          autocomplete: false,
          valueExpr: '',
          campoTabRif: '',
          displayExpr: '',
          filter: '',
          componentType: 'dynamicGrid',
          bodyFilter: '',
          settingGrid: {
            campoTabRif: '', // in questo caso lo lascio vuoto in quanto la griglia non deve effettuare operazioni salvataggio
            masterKey: 'dataField',
            keyUnique: '',
            mode: 'cell',
            remoteOperations: false, //Abilitato per il salvataggio edit e delete e get
            outputData: false,
            hoverStateEnabled: true,
            rowAlternationEnabled: true,
            repaintChangesOnly: true,
            allowUpdating: true,
            allowDeleting: true,
            allowAdding: false,
            showColBlank: false,
            showFilterSearch: false,
            searchAndSelect: false, //Cerca Valore e seleziona
            height: 500,
            rowDragging: {
              allowReordering: true,
              showDragIcons: true
            },
            colonne: [
              {
                dataField: 'caption',
                dataType: '',
                caption: 'Label',
                hideOnEdit: false
              },
              {
                dataField: 'dataField',
                dataType: '',
                caption: 'Nome Campo',

                hideOnEdit: false
              },
              {
                dataField: 'editorType',
                dataType: '',
                caption: 'Editor',
                hideOnEdit: false
              },
              {
                dataField: 'rowName',
                dataType: '',
                caption: 'Riga',
                groupIndex: 6,
                hideOnEdit: false
              },
            ],
            toolbarButtons: [
              {
                location: 'after',
                icon: 'glyphicon mdi mdi-filter-outline',
                name: 'campoEmpty',
                text: 'Spazio',
                event: "campoSemplice",
                hint: "Crea un spazio vuoto",
              },
              {
                location: 'after',
                icon: 'glyphicon mdi mdi-filter-outline',
                name: 'campoSemplice',
                text: 'Campo semplice',
                event: "campoSemplice",
                hint: "Crea un campo semplice",
              },
              {

                icon: 'glyphicon mdi mdi-file-replace-outline',
                name: 'campoDynamic',
                text: 'Campo PopUp',
                location: 'after',
                event: "campoDynamic",
                hint: "Crea un campo con la lista di selezione con funzione autocomplete",

              },

              /* {

                icon: 'glyphicon bi bi-trash3',
                name: 'campoCodiceDescrizione',
                text: 'Codice e desc',
                location: 'after',
                event: "campoCodiceDescrizione",
                hint: "Crea due campi uno con ID e la relativa descrizione",

              }, */
              {

                icon: 'glyphicon bi bi-trash3',
                name: 'campoLista',
                text: 'Campo lista',
                location: 'after',
                event: "campoLista",
                hint: "Crea un campo con un Combo box",

              },
              {

                icon: 'glyphicon bi bi-trash3',
                name: 'campoButton',
                text: 'Campo con bottone',
                location: 'after',
                event: "campoButton",
                hint: "Crea un campo con un bottone",

              },
              /* {

                icon: 'glyphicon bi bi-trash3',
                name: 'campoListaM',
                text: 'Lista con tpl',
                location: 'after',
                event: "campoListaM",
                hint: "Crea un campo con una griglia a selezione multipla o singola",

              } */
            ]
          },




        }
      }
    ]
  }
]


//{
